import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { nanoid } from 'nanoid';
import { Sizes, generateAnimations, destroyAnimations } from '../utils';

gsap.registerPlugin( ScrollTrigger );

export class ScrollScrub {
	constructor( selector, options = {} ) {
		// General
		this.elements = gsap.utils.toArray( selector );
		this.sizes = new Sizes();
		this.options = {
			...options,
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
			start: options?.start || 'top bottom',
			end: options?.end || 'bottom top',
			smooth: options?.smooth || true,
		};
		this.isEnable = false;

		// Animations
		this.timelines = [];
		this.textInstances = [];

		this.triggerIDs = [];
	}

	init() {
		if (
			! this.elements?.length ||
			this.isEnable ||
			! this.options.devices.includes( this.sizes.device )
		)
			return;
		const generalVars = {
			start: this.options.start,
			end: this.options.end,
			scrub: this.options.smooth,
		};
		if ( this.options.pin ) generalVars.pin = true;
		if ( this.options.markers ) generalVars.markers = true;

		this.elements.forEach( ( ele, index ) => {
			// Generate Animations
			const [ theTimelines, theTextInstance ] = generateAnimations(
				ele,
				this.options.animations
			);
			this.timelines[ index ] = theTimelines;
			this.textInstances[ index ] = theTextInstance;

			this.triggerIDs[ index ] = `trigger-${ nanoid( 9 ) }`;
			ScrollTrigger.create( {
				trigger: ele,
				id: this.triggerIDs[ index ],
				animation: this.timelines[ index ][ 0 ].timeline,
				...generalVars,
			} );
		} );
		this.isEnable = true;
	}

	kill() {
		if ( ! this.isEnable ) return;
		destroyAnimations(
			this.elements,
			this.options.animations,
			this.timelines,
			this.textInstances
		);
		this.triggerIDs.forEach( ( item ) => {
			ScrollTrigger.getById( item )?.kill( true );
		} );
		this.timelines = [];
		this.textInstances = [];
		this.triggerIDs = [];
		this.isEnable = false;
	}

	resize() {
		this.kill();
		this.init();
	}

	destroy() {
		this.kill();
		this.elements = null;
		this.sizes = null;
		this.options = null;
		this.timelines = null;
		this.textInstances = null;
		this.triggerIDs = null;
		this.isEnable = null;
	}
}
